<template>
  <div
    class="ticket"
    @click="onClick"
  >
    <div class="ticket__top">
      <div class="ticket__top__number">
        <i class="ri-coupon-3-line" />
        <span>{{ ticket.prefix + ticket.number }}</span>
      </div>
      <div
        v-if="tags"
        class="ticket__top__tags"
      >
        <ul>
          <li
            v-for="tag in tags"
            :key="tag"
          >
            {{ tag }}
          </li>
        </ul>
      </div>
      <div class="ticket__top__time">
        <Timer
          :ticket-time="ticket.created"
          :critical-time="($store.deviceStartData.unit_settings.time_of_waiting * 75) / 100"
        />
      </div>
    </div>
    <div class="ticket-info">
      <div v-if="name" class="ticket-info__description">
        {{name}}
      </div>
      <div v-if="surname" class="ticket-info__description">
        {{surname}}
      </div>
      <div v-if="phone" class="ticket-info__description phone">
        {{phone}}
      </div>
    </div>
    <div class="ticket__wrap">
      <div
        v-if="service"
        class="ticket__wrap__description"
      >
        {{ serviceTitle }}
      </div>
      <TicketFullDescription v-if="ticket && ticket.additional_info" :info="ticket.additional_info"/>
      <template v-if="lastAction && lastAction.status">
        <div class="ticket__wrap__action is--purple" v-if="lastAction.status === ticketStatuses.REDIRECTED">
          <i class="ri-arrow-go-forward-fill" />
          {{ 'd_ws_ticket_status_redirected' | translate({name: `${lastAction.user.name} ${lastAction.user.surname}`}) }}
        </div>
        <div class="ticket__wrap__action is--teal" v-else-if="lastAction.status === ticketStatuses.POSTPONED">
          <i class="ri-pause-circle-line"></i>
          {{ 'd_ws_ticket_status_postponed' | translate }}
        </div>
        <div class="ticket__wrap__action is--pink" v-else-if="lastAction.status === ticketStatuses.CANCELED">
          <i class="ri-close-circle-line"></i>
          {{ 'd_ws_ticket_status_canceled' | translate }}
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Timer from '../controls/Timer';
import TicketFullDescription from "./TicketFullDescription";
import {TICKET_STATUS} from '../../config'

export default {
  name: 'Ticket',
  components: {
    Timer,
    TicketFullDescription,
  },
  props: ['ticket'],
  data() {
    return {
      time: '00:00',
      timeIsOver: false
    }
  },
  computed: {
    tags () {
      let allTags = [];

      if (this.ticket && this.ticket.ticket_servicing_list && this.ticket.ticket_servicing_list.length) {
        allTags = this.ticket.ticket_servicing_list[this.ticket.ticket_servicing_list.length - 1].tag;
      }

      return allTags
    },
    service() {
      return this.$ticketService.getCurrentService(this.ticket.office_service_id);
    },
    lastAction() {
      return this.$ticketService.getLastAction(this.ticket)
    },
    ticketStatuses() {
      return TICKET_STATUS;
    },
    serviceTitle() {
      return this.$ticketService.getServiceTitle(this.service);
    },
    phone() {
      return this.ticket.phone;
    },
    name() {
      return this.ticket.name
    },
    surname() {
      return this.ticket.surname
    }
  },
  methods: {
    onClick(e) {
      this.$emit('ticketClick', {
        id: this.ticket.id,
        event: e
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ticket {
    color: var(--label-primary);
    padding: 16px;
    border-bottom: 3px dotted var(--label-quarternary);
    &:last-child {
      border-bottom: 0;
    }
    &-info {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      gap: 3px;
      .ticket-info__description.phone {
        margin-left: 10px;
      }
    }
    &__top {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      &__number {
        display: flex;
        align-items: center;
        margin-right: 35px;
        i {
          font-size: 24px;
          margin-right: 4px;
          vertical-align: middle;
        }
        span {
          font-size: 22px;
          line-height: 27px;
          font-weight: 600;
          font-feature-settings: 'zero' on;
        }
      }
      &__tags {
        ul {
          margin: 0;
          padding: 0;
          list-style: none;
          display: flex;
          flex-wrap: wrap;
          li {
            font-size: 12px;
            line-height: 130%;
            color: #fff;
            background: var(--label-tetriary);
            padding: 0 4px;
            border-radius: 4px;
            margin: 4px 8px 4px 0;
          }
        }
      }
      &__time {
        margin-left: auto;
        font-weight: 300;
        line-height: 150%;
        font-feature-settings: 'ss02' on;
        color: var(--accent-orange);
      }
    }
    &__wrap {
      &__description {
        font-weight: 300;
        line-height: 150%;
        font-size: 16px;
        font-feature-settings: 'ss02' on;
      }
      &__action {
        margin-top: 10px;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 130%;
        i {
          vertical-align: middle;
          font-size: 20px;
          margin-right: 4px;
          font-weight: normal;
        }
      }
      &__comment {
        margin-top: 12px;
        color: var(--label-secondary);
        font-size: 12px;
        line-height: 130%;
        display: flex;
        align-items: center;
        span {
          font-weight: 600;
        }
        i {
          font-size: 20px;
          margin-right: 4px;
        }
      }
    }
    &__menu {
      position: absolute;
    }
    &:hover {
      background: var(--light-03);
    }
  }

  @media (max-width: 425px) {
    .ticket {
      &__top {
        flex-flow: wrap;
        &__number {
          order: 0;
        }
        &__time {
          order: 1;
        }
        &__tags {
          order: 2;
          margin-top: 8px;
        }
      }
    }
  }
</style>
